export default __webpack_public_path__ + "../staticImages/google_name.png";